import styles from './error.module.scss';

export const Error = () => (
	<div className={styles.errorPage}>
		<h1>404 -Страница не найдена</h1>
	</div>
);
